import { FC } from 'react'

export const IconCheckboxChecked: FC = () => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#09909E" height="20" rx="2" width="20" />
      <path
        d="M14 7L8.5 12L6 9.72727"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}
